import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { createContext, useContext } from "react";
const FieldTreeContext = createContext(null);
function useFieldTreeContext() {
  const ctx = useContext(FieldTreeContext);
  if (!ctx) {
    throw new Error("useFieldTreeContext must be used inside FieldTreeProvider");
  }
  return ctx;
}
function FieldTreeProvider(t0) {
  const $ = c(3);
  const {
    value,
    children
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = /* @__PURE__ */ jsx(FieldTreeContext.Provider, { value, children });
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export {
  FieldTreeProvider,
  useFieldTreeContext
};
//# sourceMappingURL=field-tree-context.js.map
